/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_TitleInputs */



/**
* | output |
* | --- |
* | "CCSL Export" |
*
* @param {Ccsl_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_title = /** @type {((inputs?: Ccsl_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation CCSL")
	if (locale === "de") return /** @type {LocalizedString} */ ("CCSL-Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione CCSL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт CCSL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación CCSL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CCSL出口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCSLエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीसीएसएल निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação CCSL")
	return /** @type {LocalizedString} */ ("CCSL Export")
});